export const SUPPORT_EMAIL = 'helpdesk@fuerstenberg-institut.de';
